<!-- @format -->

<template>
  <!-- 移动端 -->
 <div>
  <div
  v-if="!$isMobile"
    :class="['admin-header']"
    :style="{
      background:
        'url(' +
        require('../../assets/img/topheadbg.png') +
        ')no-repeat center top',
    }"
  >
    <div :class="['admin-header-wide']">
        <a-col :sm="8" :md="8" :lg="8" class="logo fl">
          <router-link to="/" :class="['logo']">
            <img src="@/assets/img/logo.svg" />
          </router-link>
        </a-col>
        <a-col :lg="{ span: 6, offset: 1 }" class="fl slogan">
          <img src="@/assets/img/slogan.svg" />
        </a-col>
        <a-col :md="7" :lg="{ span: 7, offset: 1 }" class="topsearch fr">
          <a-input
            placeholder="搜索"
            class="from-control"
            v-model="content"
          ></a-input>
          <a-button
            type="primary"
            @click="goSearch()"
            class="btn-default"
          ></a-button>
        </a-col>
    </div>
    <div class="admin-header-menu" :style="`width: 100%`"  v-if="!$isMobile">
      <a-menu mode="horizontal" class="ant-menu-dark npc-menu">
        <a-sub-menu
          :class="{
            current: pageName == '首页',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '首页' }"
            ><router-link :to="{ name: '首页', params: { id: 1 } }"
              >首页</router-link
            ></template
          >
        </a-sub-menu>
        <a-sub-menu
          :class="{
            current:
              pageName == '院务公开' ||
              pageName == '医院简介' ||
              pageName == '领导班子' ||
              pageName == '组织机构' ||
              pageName == '信息公开' ||
              pageName == '环境设备',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '院务公开' }"
            ><router-link :to="{ name: '医院概况', params: { id: 2 } }"
              >院务公开</router-link
            ></template
          >
          <a-menu-item-group  class="custom-padding">
            <a-menu-item key="setting:1"
              ><router-link :to="{ name: '医院概况', params: { id: 21 } }"
                >医院简介</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:2"
              ><router-link :to="{ name: '领导班子', params: { id: 22 } }"
                >领导班子</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:3"
              ><router-link :to="{ name: '组织机构', params: { id: 23 } }"
                >组织机构</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:4"
              ><router-link :to="{ name: '信息公开', params: { id: 25 } }"
                >信息公开</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:5"
              ><router-link :to="{ name: '环境设备', params: { id: 24 } }"
                >环境设备</router-link
              ></a-menu-item
            >
          </a-menu-item-group>
        </a-sub-menu>

        <a-sub-menu
          :class="{
            current:
              pageName == '医院动态' ||
              pageName == '新闻中心' ||
              pageName == '通知公告' ||
              pageName == '新闻视频',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '医院动态' }"
            ><router-link :to="{ name: '医院动态', params: { id: 3 } }"
              >新闻中心</router-link
            ></template
          ><a-menu-item-group class="custom-padding">
            <a-menu-item key="setting:5"
              ><router-link :to="{ name: '医院动态', params: { id: 25 } }"
                >医院动态</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:6"
              ><router-link :to="{ name: '通知公告', params: { id: 26 } }"
                >通知公告</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:7"
              ><router-link :to="{ name: '新闻视频', params: { id: 27 } }"
                >新闻视频</router-link
              ></a-menu-item
            >

          </a-menu-item-group>
        </a-sub-menu>

        <a-sub-menu
          :class="{
            current:
              pageName == '党风廉政' ||
              pageName == '党群动态' ||
              pageName == '廉政建设',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '党风廉政' }"
            ><router-link :to="{ name: '党风廉政', params: { id: 4 } }"
              >党风廉政</router-link
            ></template
          >
          <a-menu-item-group class="custom-padding">
            <a-menu-item key="setting:8"
              ><router-link :to="{ name: '党风廉政', params: { id: 28 } }"
                >党群动态</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:9"
              ><router-link :to="{ name: '廉政建设', params: { id: 29 } }"
                >廉政建设</router-link
              ></a-menu-item
            >
          </a-menu-item-group>
        </a-sub-menu>

        <a-sub-menu
          :class="{
            current:
              pageName == '学科建设' ||
              pageName == '科室介绍' ||
              pageName == '专家介绍' ||
              pageName == '技术优势',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '学科建设' }"
            ><router-link :to="{ name: '学科建设', params: { id: 5 } }"
              >学科建设</router-link
            ></template
          >
          <a-menu-item-group class="custom-padding">
            <a-menu-item key="setting:10"
              ><router-link :to="{ name: '学科建设', params: { id: 30 } }"
                >科室介绍</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:11"
              ><router-link :to="{ name: '专家介绍', params: { id: 31 } }"
                >专家介绍</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:12"
              ><router-link :to="{ name: '技术优势', params: { id: 32 } }"
                >技术优势</router-link
              ></a-menu-item
            >
            <a-menu-item
              ><a href="http://mzy.sxakzy.com.cn/">名中医工作室</a></a-menu-item
            >
          </a-menu-item-group>
        </a-sub-menu>

        <a-sub-menu
          :class="{
            current: pageName == '医疗管理',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '医疗管理' }"
            ><router-link :to="{ name: '医疗管理', params: { id: 6 } }"
              >医疗管理</router-link
            ></template
          >
        </a-sub-menu>
        <a-sub-menu
          :class="{
            current: pageName == '护理天地',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '护理天地' }"
            ><router-link :to="{ name: '护理天地', params: { id: 7 } }"
              >护理天地</router-link
            ></template
          >
        </a-sub-menu>
        <a-sub-menu
          :class="{
            current:
              pageName == '科研教学' ||pageName == '进修申请'||
              pageName == '科研教学动态' ||
              pageName == '规范化培训',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '科研教学' }"
            ><router-link :to="{ name: '科研教学', params: { id: 8 } }"
              >科研教学</router-link
            ></template
          >
          <a-menu-item-group class="custom-padding">
            <a-menu-item key="setting:13"
              ><router-link :to="{ name: '科研教学', params: { id: 33 } }"
                >科研教学动态</router-link
              ></a-menu-item
            >
             <a-menu-item key="setting:15"
              ><router-link :to="{ name: '进修申请', params: { id: 37 } }"
                >进修申请</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:14"
              ><router-link :to="{ name: '规范化培训', params: { id: 34 } }"
                >住院医师规范化培训</router-link
              ></a-menu-item
            >
            <a-menu-item
              ><a href="http://mzy.sxakzy.com.cn/llwyh/"
                >伦理平台</a
              ></a-menu-item
            >
            <a-menu-item
              ><a href="http://mzy.sxakzy.com.cn/ywlcsy/"
                >国家药物/医疗器械临床试验机构</a
              ></a-menu-item
            >
          </a-menu-item-group>
        </a-sub-menu>
        <a-sub-menu
          :class="{
            current: pageName == '健康教育',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '健康教育' }"
            ><router-link :to="{ name: '健康教育', params: { id: 9 } }"
              >健康教育</router-link
            ></template
          >
        </a-sub-menu>
        <a-sub-menu
          :class="{
            current: (pageName == '服务患者') | (pageName == '就医指南')| (pageName == '价格公示'),
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '服务患者' }"
            ><router-link :to="{ name: '服务患者', params: { id: 10 } }"
              >服务患者</router-link
            ></template
          >
           <a-menu-item-group>
            <a-menu-item key="setting:17"
              ><router-link :to="{ name: '就医指南', params: { id: 38} }"
                >就医指南</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:2"
              ><router-link :to="{ name: '价格公示', params: { id: 39 } }"
                >价格公示</router-link
              ></a-menu-item
            >
          </a-menu-item-group>
        </a-sub-menu>
        <a-sub-menu>
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '高新医院' }"
            >
            <router-link :to="{ name: '高新院区', params:{} }"
              >高新院区</router-link
            ></template
          >
        </a-sub-menu>
        <!-- </a-menu-item> -->

        <a-sub-menu
          :class="{
            current:
              pageName == '联系我们' ||
              pageName == '联系地址' ||
              pageName == '在线留言',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '联系我们' }"
            ><router-link :to="{ name: '联系我们', params: { id: 11 } }"
              >联系我们</router-link
            ></template
          >
          <a-menu-item-group class="custom-padding">
            <a-menu-item key="setting:15"
              ><router-link :to="{ name: '联系我们', params: { id: 35 } }"
                >联系地址</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:16"
              ><router-link :to="{ name: '在线留言', params: { id: 36 } }"
                >在线留言</router-link
              ></a-menu-item
            >
          </a-menu-item-group>
        </a-sub-menu>
      </a-menu>
    </div>
    <GlobalMenu v-if="isShow"/>
  </div>
  <div
  v-else
    :class="['admin-header']"
    :style="{
      background:
        'url(' +
        require('../../assets/img/topheadbg.png') +
        ')no-repeat center top',
    }"
  >
    <div :class="['admin-header-wide']">
          <img class="logo" src="@/assets/img/logo.svg" />
          <img src="@/assets/img/slogan.svg"   class="fl slogan"/>
          <img src="@/assets/img/mobile-nav.svg" alt="" class="tab" v-if="!$store.state.menuShow" @click="handleMenuShow(true)">
          <img src="@/assets/img/mobile-nav-select.svg" class="tab" alt="" v-else   @click="handleMenuShow(false)">
    </div>
    <div class="admin-header-menu" :style="`width: 100%`"  v-if="!$isMobile">
      <a-menu mode="horizontal" class="ant-menu-dark npc-menu">
        <a-sub-menu
          :class="{
            current: pageName == '首页',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '首页' }"
            ><router-link :to="{ name: '首页', params: { id: 1 } }"
              >首页</router-link
            ></template
          >
        </a-sub-menu>
        <a-sub-menu
          :class="{
            current:
              pageName == '院务公开' ||
              pageName == '医院简介' ||
              pageName == '领导班子' ||
              pageName == '组织机构' ||
              pageName == '信息公开' ||
              pageName == '环境设备',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '院务公开' }"
            ><router-link :to="{ name: '医院概况', params: { id: 2 } }"
              >院务公开</router-link
            ></template
          >
          <a-menu-item-group>
            <a-menu-item key="setting:1"
              ><router-link :to="{ name: '医院概况', params: { id: 21 } }"
                >医院简介</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:2"
              ><router-link :to="{ name: '领导班子', params: { id: 22 } }"
                >领导班子</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:3"
              ><router-link :to="{ name: '组织机构', params: { id: 23 } }"
                >组织机构</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:4"
              ><router-link :to="{ name: '信息公开', params: { id: 25 } }"
                >信息公开</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:5"
              ><router-link :to="{ name: '环境设备', params: { id: 24 } }"
                >环境设备</router-link
              ></a-menu-item
            >
          </a-menu-item-group>
        </a-sub-menu>

        <a-sub-menu
          :class="{
            current:
              pageName == '医院动态' ||
              pageName == '新闻中心' ||
              pageName == '通知公告' ||
              pageName == '新闻视频',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '医院动态' }"
            ><router-link :to="{ name: '医院动态', params: { id: 3 } }"
              >新闻中心</router-link
            ></template
          >
            <a-menu-item key="setting:5"
              ><router-link :to="{ name: '医院动态', params: { id: 25 } }"
                >医院动态</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:6"
              ><router-link :to="{ name: '通知公告', params: { id: 26 } }"
                >通知公告</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:7"
              ><router-link :to="{ name: '新闻视频', params: { id: 27 } }"
                >新闻视频</router-link
              ></a-menu-item
            >
        </a-sub-menu>

        <a-sub-menu
          :class="{
            current:
              pageName == '党风廉政' ||
              pageName == '党群动态' ||
              pageName == '廉政建设',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '党风廉政' }"
            ><router-link :to="{ name: '党风廉政', params: { id: 4 } }"
              >党风廉政</router-link
            ></template
          >
          <a-menu-item-group>
            <a-menu-item key="setting:8"
              ><router-link :to="{ name: '党风廉政', params: { id: 28 } }"
                >党群动态</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:9"
              ><router-link :to="{ name: '廉政建设', params: { id: 29 } }"
                >廉政建设</router-link
              ></a-menu-item
            >
          </a-menu-item-group>
        </a-sub-menu>

        <a-sub-menu
          :class="{
            current:
              pageName == '学科建设' ||
              pageName == '科室介绍' ||
              pageName == '专家介绍' ||
              pageName == '技术优势',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '学科建设' }"
            ><router-link :to="{ name: '学科建设', params: { id: 5 } }"
              >学科建设</router-link
            ></template
          >
          <a-menu-item-group>
            <a-menu-item key="setting:10"
              ><router-link :to="{ name: '学科建设', params: { id: 30 } }"
                >科室介绍</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:11"
              ><router-link :to="{ name: '专家介绍', params: { id: 31 } }"
                >专家介绍</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:12"
              ><router-link :to="{ name: '技术优势', params: { id: 32 } }"
                >技术优势</router-link
              ></a-menu-item
            >
            <a-menu-item
              ><a href="http://mzy.sxakzy.com.cn/">名中医工作室</a></a-menu-item
            >
          </a-menu-item-group>
        </a-sub-menu>

        <a-sub-menu
          :class="{
            current: pageName == '医疗管理',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '医疗管理' }"
            ><router-link :to="{ name: '医疗管理', params: { id: 6 } }"
              >医疗管理</router-link
            ></template
          >
        </a-sub-menu>
        <a-sub-menu
          :class="{
            current: pageName == '护理天地',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '护理天地' }"
            ><router-link :to="{ name: '护理天地', params: { id: 7 } }"
              >护理天地</router-link
            ></template
          >
        </a-sub-menu>
        <a-sub-menu
          :class="{
            current:
              pageName == '科研教学' ||
               pageName == '进修申请'||
              pageName == '科研教学动态' ||
              pageName == '规范化培训',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '科研教学' }"
            ><router-link :to="{ name: '科研教学', params: { id: 8 } }"
              >科研教学</router-link
            ></template
          >
          <a-menu-item-group>
            <a-menu-item key="setting:13"
              ><router-link :to="{ name: '科研教学', params: { id: 33 } }"
                >科研教学动态</router-link
              ></a-menu-item
            >
             <a-menu-item key="setting:13"
              ><router-link :to="{ name: '进修申请', params: { id: 37 } }"
                >进修申请</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:14"
              ><router-link :to="{ name: '规范化培训', params: { id: 34 } }"
                >住院医师规范化培训</router-link
              ></a-menu-item
            >
            <a-menu-item
              ><a href="http://mzy.sxakzy.com.cn/llwyh/"
                >伦理平台</a
              ></a-menu-item
            >
            <a-menu-item
              ><a href="http://mzy.sxakzy.com.cn/ywlcsy/"
                >国家药物/医疗器械临床试验机构</a
              ></a-menu-item
            >
          </a-menu-item-group>
        </a-sub-menu>
        <a-sub-menu
          :class="{
            current: pageName == '健康教育',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '健康教育' }"
            ><router-link :to="{ name: '健康教育', params: { id: 9 } }"
              >健康教育</router-link
            ></template
          >
        </a-sub-menu>
        <a-sub-menu
          :class="{
            current: (pageName == '服务患者') || (pageName == '就医指南')||pageName == '价格公示',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '服务患者' }"
            ><router-link :to="{ name: '服务患者', params: { id: 10 } }"
              >服务患者</router-link
            ></template
          >
        </a-sub-menu>
        <a-sub-menu>
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '高新医院' }"
            >
            <router-link :to="{ name: '高新院区', params:{} }"
              >高新院区</router-link
            ></template
          >
        </a-sub-menu>
        <!-- </a-menu-item> -->

        <a-sub-menu
          :class="{
            current:
              pageName == '联系我们' ||
              pageName == '联系地址' ||
              pageName == '在线留言',
          }"
        >
          <template #icon>
            <setting-outlined />
          </template>
          <template #title :class="{ current: pageName == '联系我们' }"
            ><router-link :to="{ name: '联系我们', params: { id: 11 } }"
              >联系我们</router-link
            ></template
          >
          <a-menu-item-group>
            <a-menu-item key="setting:15"
              ><router-link :to="{ name: '联系我们', params: { id: 35 } }"
                >联系地址</router-link
              ></a-menu-item
            >
            <a-menu-item key="setting:16"
              ><router-link :to="{ name: '在线留言', params: { id: 36 } }"
                >在线留言</router-link
              ></a-menu-item
            >
          </a-menu-item-group>
        </a-sub-menu>
      </a-menu>
    </div>
    <GlobalMenu v-if="$store.state.menuShow"/>
  </div>
 </div>
</template>

<script>
import GlobalMenu from "./GlobaMenu.vue"
import { getNewsdetail } from "@/api";
import {
  MailOutlined,
  AppstoreOutlined,
  SettingOutlined,
} from "@ant-design/icons-vue";
export default {
  name: "GeneralHeader",
  components: {
    MailOutlined,
    AppstoreOutlined,
    SettingOutlined,
    GlobalMenu
  },
  data() {
    return {
      isShow: false,
      index: 1,
      content: "",
      pageName: "首页",
      //是否显示导航栏
      isShow:false
    };
  },
  created() {
    let url = window.location.href;
    let pos = url.lastIndexOf("/");
    let no = url.slice(pos + 1);
    this.index = Number(no);
  },
  methods: {
    goSearch() {
      this.$router.push({
        name: "搜索结果页",
        params: { title: this.content },
      });
    },
    async getNewsdetail() {
      const params = {
        id: this.$route.params.id,
      };
      getNewsdetail(params).then((res) => {
        this.pageName = res.data.name;
      });
    },
    handleMenuShow(value){
      console.log('value',value)
this.$store.commit('SETMENUSTATE',value)
    }
  },
  watch: {
    $route(to, from) {
      this.isShow=false
      if (to.name != "内容页") {
        this.pageName = to.name;
      } else {
        this.getNewsdetail();
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "@/assets/css/basic.css";
@import "@/assets/css/index.css";
@import "@/assets/css/mobile.css";
.custom-padding {
  padding:0 15px;
}
.ant-layout-header {
  padding: 0px 0px;
  // height: 230px;
}
.admin-header {
  background-size: cover !important;
}

.admin-header-wide {
  padding-top: 17px;
  min-width: 1200px;
  margin: 0 8%;
  overflow: hidden;
  zoom: 1;
  height: 170px;
}

.admin-header .admin-header-wide .logo {
  height: 146px;
  vertical-align: top;
  display: inline-block;
  text-align: left;
  cursor: pointer;
  color: inherit;
}
.admin-header .admin-header-wide .logo img {
  width: 100%;
}
.slogan {
  padding-top: 36px;
}
.slogan span {
  display: block;
  height: 40px;
  vertical-align: top;
  margin: 20px 0;
}
.slogan span img {
  width: 100%;
}

.topsearch {
  background: url(../../assets/img/top-tmbg.png) repeat;
  border: 1px solid #bdbcbc;
  height: 48px;
  overflow: hidden;
  zoom: 1;
  border-radius: 24px;
  -webkit-border-radius: 24px;
  -moz-border-radius: 24px;
  padding: 0 10px;
  max-width: 484px;
  margin-top: 43px;
}
.topsearch input {
  display: block;
  float: left;
}
.topsearch input.from-control {
  width: 70%;
  line-height: 48px;
  height: 48px;
  color: #b8b8b8;
  border: none !important;
  font-size: 16px;
  letter-spacing: 2px;
  background: none !important;
}
.topsearch button.btn-default {
  width: 28px;
  height: 48px;
  background: url(../../assets/img/fdj-icon.png) no-repeat !important;
  float: right;
  background-color: none !important;
  border: none;
}

.admin-header-menu {
  height: 60px;
  background: #106d92;
  padding: 11px 0;
}
.npc-menu {
  margin: 0 8% !important; /*--min-width:1200px--*/
  display: flex;
  background: none !important;
  box-sizing: border-box;
}
.npc-menu li {
  font-size: 20px;
  font-weight: bold;
  width: 8.3%;
  text-align: center;
  box-sizing: border-box;
  color: #fff;
  line-height: 38px;
}
.npc-menu li a {
  color: #fff;
  display: block;
}
.npc-menu li:hover,
.npc-menu li.current {
  background: url(../../assets/img/menu-hoverbg1.png) no-repeat center !important;
  color: #fff;
}
.npc-menu li:hover a,
.npc-menu li.current a {
  color: #fff !important;
}
.ant-menu.ant-menu-dark .ant-menu-item-selected,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
  background: none;
}
.npc-menu .ant-menu-submenu-active,
.npc-menu .router-link-active {
  background: url(../../assets/img/menu-hoverbg1.png) no-repeat center !important;
  color: #fff;
}

.ant-menu-item-group .ant-menu-item-group-list .ant-menu-item {
  text-align: center;
}
.ant-menu-item-group-list .ant-menu-item,
.ant-menu-item-group-list .ant-menu-submenu-title {
  padding: 0 !important;
  font-size: 16px;
}
.ant-menu-item:hover,
.ant-menu-item-active,
.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.ant-menu-submenu-active,
.ant-menu-submenu-title:hover {
  color: #106d92 !important;
}
.ant-menu-submenu > .ant-menu {
  padding-bottom: 10px !important;
}
.ant-menu-submenu-popup {
  top: 231px !important;
}
.ant-menu-item-selected > a,
.ant-menu-item-selected > a:hover {
  color: #106d92 !important;
}
.ant-menu-item .ant-menu-submenu-title {
  padding: 0 !important;
}
.tab{
  display: none;
}
@media screen and (max-width: 1680px) {
  .npc-menu li {
    font-size: 18px;
  }
}
@media screen and (max-width: 1600px) {
  .npc-menu li {
    font-size: 17px;
  }
}
@media screen and (max-width: 1440px) {
  .npc-menu li {
    font-size: 16px;
  }
}
@media screen and (max-width: 1400px) {
  .npc-menu li {
    font-size: 16px;
  }
}
@media screen and (max-width: 1366px) {
  .npc-menu li {
    font-size: 16px;
  }
}
@media screen and (max-width: 768px) {
  .ant-layout-header{
  height: 62px !important;
  line-height: 62px !important;
  display: flex;
  align-items: center;
}
  .admin-header-wide {
    min-width: 100vw;
    height: 62px;
    margin: 0 auto;
    padding: 0 23px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .admin-header-wide .ant-row {
    width: 100vw;
    height: 62px;
    display: flex;
    justify-content: space-around;
  }
  .logo {
    width: 118px;
    height: 40px !important;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .slogan {
    width: 136px !important;
    height: 27px !important;
    padding-top: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .admin-header-menu,
  .topsearch {
    display: none;
  }
  .tab {
    display: block;
    width: 20px;
    height: 14px;
    img{
      width:100%;
      height:100%;
    }
  }
}
</style>
